var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchHeartIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.80625 2.20635C2.70639 1.30649 3.92707 0.800975 5.19985 0.800975C6.47264 0.800975 7.69332 1.30649 8.59345 2.20635L9.99985 3.61155L11.4063 2.20635C11.849 1.7479 12.3787 1.38223 12.9643 1.13066C13.5499 0.8791 14.1798 0.746686 14.8171 0.741148C15.4545 0.73561 16.0865 0.857058 16.6764 1.09841C17.2663 1.33975 17.8023 1.69617 18.253 2.14685C18.7036 2.59754 19.0601 3.13347 19.3014 3.72337C19.5427 4.31327 19.6642 4.94534 19.6587 5.58268C19.6531 6.22002 19.5207 6.84987 19.2691 7.43549C19.0176 8.02111 18.6519 8.55077 18.1935 8.99355L9.99985 17.1884L1.80625 8.99355C0.906393 8.09342 0.400879 6.87274 0.400879 5.59995C0.400879 4.32716 0.906393 3.10648 1.80625 2.20635V2.20635Z",
    fill: "#8D96B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchHeartIco);
export default __webpack_public_path__ + "static/media/SearchHeartIco.cefe0982b9ecc3cbdafd9457265eab81.svg";
export { ForwardRef as ReactComponent };